import { ContactDoc, ContactResponse, ContactsResponse } from '@/types/entities';
import { FilterRequest } from '@/types';
import { ApiService } from './api.service';
import { endpoints } from './endpoints';

/**
 * Service for handling contacts-related API calls
 */
export class ContactsApiService extends ApiService {
  getFilteredContacts = async (filters: FilterRequest): Promise<ContactsResponse> =>
    this.post(endpoints.contacts.filtered, filters);

  getContacts = async (params?: { page?: number; pageSize?: number }): Promise<ContactsResponse> =>
    this.post(endpoints.contacts.filtered, {
      filter: {},
      ...params,
    });

  deleteContact = async (id: string): Promise<void> => this.delete(endpoints.contacts.delete(id));

  getContactById = async (id: string): Promise<ContactResponse> =>
    this.get(endpoints.contacts.byId(id));

  createContact = async (data: Partial<ContactDoc>): Promise<ContactDoc> =>
    this.post(endpoints.contacts.create, data);

  updateContact = async (id: string, data: Partial<ContactDoc>): Promise<ContactDoc> =>
    this.patch(endpoints.contacts.update(id), data);

  getContactActivities = async (id: string): Promise<any[]> =>
    this.get(endpoints.contacts.activities(id));

  getContactsByOrganization = async (
    organizationId: string,
    params?: { page?: number; pageSize?: number }
  ): Promise<ContactsResponse> =>
    this.post(endpoints.contacts.filtered, {
      organization: organizationId,
      page: params?.page,
      pageSize: params?.pageSize,
    });
}

// Export a singleton instance
export const contactsApiService = new ContactsApiService();

// Named exports for convenience
export const {
  getFilteredContacts,
  getContacts,
  deleteContact,
  getContactById,
  createContact,
  updateContact,
  getContactActivities,
  getContactsByOrganization,
} = contactsApiService;
